
import ChartFail from "../../../assets/filled/ChartFail.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ChartFailIcon({ className, dataTestid = "ChartFailIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ChartFail data-testid={dataTestid} className={classes} {...rest} />
  );
}
